import { useToast } from '@repo/design-system/index'
import { ActivityComponentType, useActivity } from '@stackflow/react'
import { useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { axiosGet, axiosPost } from '../../../modules/axiosHelper'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useWebviewNavigation from '../../../modules/hooks/webview/common/useWebviewNavigation'
import { s_process, s_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import LessonStylePopupBody from '../../new-portal/lessons/LessonStylePopupBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface ILessonStyle {
  params: {
    lessonId: string
  }
}

export const handleBack = (activity, popBackToRingleApp, pop) => {
  if (activity.isRoot) {
    popBackToRingleApp()
  } else {
    pop()
  }
}

const LessonStyleActivity: ActivityComponentType = ({ params }: ILessonStyle) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { currentUser } = useCurrentUser()
  const { toastSuccess } = useToast()
  const { t } = useTranslation()
  const router = useAppRouter()

  const pathParams = { lessonId: Number(params.lessonId) }

  const [lessonStyleData, setData] = useState(null)
  const [isWriting, setIsWriting] = useState(false)

  const activity = useActivity()
  const { popBackToRingleApp } = useWebviewNavigation()

  // API call
  const fetchData = async () => {
    const response = await axiosGet(apis.lessons.setting(params.lessonId))

    if (response) {
      setData(response.response)
    }
  }

  const fetchLessonData = async () => {
    const response = await axiosGet(apis.lessons.preparation.getV5(pathParams))

    if (response) {
      setIsWriting(response.lesson.course.is_writing)
    }
  }
  // data fetch
  useEffect(() => {
    fetchData()
    fetchLessonData()
  }, [])

  //webview 에서 취소 / 저장 버튼
  const handleCancelLessonStyleWebview = (e) => {
    e.preventDefault()
    handleBack(activity, popBackToRingleApp, pop)
    e.stopPropagation()
  }

  const handleSubmitLessonStyleWebview = async (
    item,
    lessonId,
    skipIntro,
    intro,
    allowRecord,
    allowCAF,
    lessonMode,
    lessonOption,
    otherRequest,
    intensiveArea,
    selectedRequest,
    convertList
  ) => {
    const url = `${apis.lessons.setting(params.lessonId)}`
    const response = await axiosPost(url, {
      lesson_id: lessonId,
      skip_intro: skipIntro,
      introduction: skipIntro ? intro : item.intro.desc,
      allow_record: allowRecord,
      allow_caf: allowCAF,
      class_type: lessonMode,
      correcting_style: lessonOption,
      other_request: otherRequest,
      ringle_area: convertList(intensiveArea),
      selected_requests: convertList(selectedRequest),
    })

    if (response.success) {
      toastSuccess(t(s_upcoming_lessons.after_tutor_cancel.your_option_change_has_been_completed))

      setTimeout(() => {
        handleBack(activity, popBackToRingleApp, pop)
      }, 3000)
    }
  }
  return (
    <WebviewStackContainer onBack={pop} title={t(s_process.require_correction)}>
      {lessonStyleData && (
        <LessonStylePopupBody
          item={lessonStyleData}
          lessonId={params.lessonId}
          isConfirmModalOpen={false}
          isWriting={isWriting}
          currentUser={currentUser}
          handleCancelLessonStyleWebview={handleCancelLessonStyleWebview}
          handleSubmitLessonStyleWebview={handleSubmitLessonStyleWebview}
        />
      )}
    </WebviewStackContainer>
  )
}

export default LessonStyleActivity
